import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex h-full w-96 shrink-0 flex-col border-l border-gray-200 bg-white" }
const _hoisted_2 = { class: "flex items-start justify-between gap-2 border-b border-gray-100 px-4 py-3" }
const _hoisted_3 = { class: "min-w-0" }
const _hoisted_4 = { class: "flex items-center gap-1.5 text-sm font-semibold text-gray-800" }
const _hoisted_5 = { class: "mt-0.5 truncate text-xs text-gray-500" }
const _hoisted_6 = { class: "font-medium text-gray-700" }
const _hoisted_7 = {
  key: 0,
  class: "ml-1"
}
const _hoisted_8 = { class: "flex-1 overflow-y-auto px-4 py-3" }
const _hoisted_9 = { class: "mt-3 flex items-center gap-2" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "mt-2 text-xs text-green-600"
}
const _hoisted_12 = {
  key: 1,
  class: "mt-3 space-y-1.5"
}
const _hoisted_13 = { class: "border-t border-gray-100 p-3" }
const _hoisted_14 = {
  key: 0,
  class: "mb-1.5 text-xs text-red-500"
}
const _hoisted_15 = ["onKeydown"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 0,
  class: "h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"
}

import { ArrowPathIcon, SparklesIcon, XMarkIcon } from '@heroicons/vue/24/solid'
import Cookies from 'js-cookie'
import { ref } from 'vue'


export default {
  __name: 'CustomerSmsSimulator',
  props: {
  conversationUserPairId: { type: [String, Number], required: true },
  customerName: { type: String, default: '' },
  customerPhone: { type: String, default: '' }
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const body = ref('')
const sending = ref(false)
const error = ref('')
const sent = ref([])
const clearing = ref(false)
const clearNote = ref('')

const send = async () => {
  const text = body.value.trim()
  if (!text || sending.value) return
  sending.value = true
  error.value = ''
  try {
    const res = await fetch(
      process.env.VUE_APP_API_SERVER +
        `conversation_user_pairs/${props.conversationUserPairId}/simulated_inbound_messages`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${Cookies.get('auth_token')}`,
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ simulated_message: { body: text } })
      }
    )
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    sent.value.unshift(text)
    body.value = ''
  } catch (e) {
    error.value = 'Could not inject message (dev-only endpoint).'
  } finally {
    sending.value = false
  }
}

const clearSessions = async () => {
  if (clearing.value) return
  clearing.value = true
  clearNote.value = ''
  error.value = ''
  try {
    const res = await fetch(
      process.env.VUE_APP_API_SERVER + `conversation_user_pairs/${props.conversationUserPairId}/ai_session`,
      {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${Cookies.get('auth_token')}`,
          Accept: 'application/json'
        }
      }
    )
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    const data = await res.json().catch(() => ({}))
    const count = data.sessions ?? 0
    clearNote.value = `Cleared ${count} session${count === 1 ? '' : 's'} — the customer is fresh again.`
    sent.value = []
  } catch (e) {
    error.value = 'Could not clear AI sessions (dev-only endpoint).'
  } finally {
    clearing.value = false
  }
}

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_Transition, {
    appear: "",
    "enter-active-class": "transition-transform duration-300 ease-out",
    "enter-from-class": "translate-x-full",
    "enter-to-class": "translate-x-0",
    "leave-active-class": "transition-transform duration-200 ease-in",
    "leave-from-class": "translate-x-0",
    "leave-to-class": "translate-x-full"
  }, {
    default: _withCtx(() => [
      _createElementVNode("aside", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(SparklesIcon), { class: "h-4 w-4 text-indigo-500" }),
              _cache[2] || (_cache[2] = _createTextVNode(" Customer simulator ", -1))
            ]),
            _createElementVNode("p", _hoisted_5, [
              _cache[3] || (_cache[3] = _createTextVNode(" Texting as ", -1)),
              _createElementVNode("span", _hoisted_6, _toDisplayString(__props.customerName || 'customer'), 1),
              (__props.customerPhone)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "· " + _toDisplayString(__props.customerPhone), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "rounded-md p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600",
            onClick: _cache[0] || (_cache[0] = $event => (emit('close')))
          }, [
            _createVNode(_unref(XMarkIcon), { class: "h-5 w-5" })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-xs leading-relaxed text-gray-500" }, " Send a message as this customer to test the agent end to end. It injects a real inbound SMS through the full pipeline — the message and the agent's reply appear in the thread on the left. ", -1)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              type: "button",
              disabled: clearing.value,
              class: "inline-flex items-center gap-1.5 rounded-lg border border-gray-200 px-3 py-1.5 text-xs font-medium text-gray-600 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50",
              onClick: clearSessions
            }, [
              _createVNode(_unref(ArrowPathIcon), {
                class: _normalizeClass(["h-3.5 w-3.5", { 'animate-spin': clearing.value }])
              }, null, 8, ["class"]),
              _cache[4] || (_cache[4] = _createTextVNode(" Clear AI sessions ", -1))
            ], 8, _hoisted_10)
          ]),
          (clearNote.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(clearNote.value), 1))
            : _createCommentVNode("", true),
          (sent.value.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sent.value, (m, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: i,
                    class: "ml-auto max-w-[85%] rounded-2xl rounded-br-sm bg-indigo-50 px-3 py-2 text-xs text-indigo-900"
                  }, _toDisplayString(m), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          (error.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(error.value), 1))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((body).value = $event)),
            rows: "3",
            placeholder: "Type the customer's message…",
            class: "w-full resize-none rounded-lg border border-gray-200 px-3 py-2 text-sm focus:border-indigo-400 focus:outline-none focus:ring-1 focus:ring-indigo-400",
            onKeydown: _withKeys(_withModifiers(send, ["exact","prevent"]), ["enter"])
          }, null, 40, _hoisted_15), [
            [_vModelText, body.value]
          ]),
          _createElementVNode("button", {
            type: "button",
            disabled: sending.value || !body.value.trim(),
            class: "mt-2 flex w-full items-center justify-center gap-2 rounded-lg bg-indigo-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-50",
            onClick: send
          }, [
            (sending.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(sending.value ? 'Sending…' : 'Send as customer'), 1)
          ], 8, _hoisted_16)
        ])
      ])
    ]),
    _: 1
  }))
}
}

}